import { render, staticRenderFns } from "./ClientCategory.vue?vue&type=template&id=46c81310"
import script from "./ClientCategory.vue?vue&type=script&lang=js"
export * from "./ClientCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports